export default ['$rootScope', 'access', ($rootScope, access) => {
    let hasIntegration = () => {
        return !!($rootScope.currentProperty && $rootScope.currentProperty.integration) &&
            !access.check('admin');
    };

    let hasLinkedIntegration = () => {
        return !!($rootScope.currentProperty && $rootScope.currentProperty.integration);
    };

    let isNonRevspa = () => {
        return !!($rootScope.currentProperty && $rootScope.currentProperty.property_type);
    };

    return {
        hasIntegration,
        hasLinkedIntegration,
        isNonRevspa
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/services/integration.service.js